import React from "react";
import { Card, ListGroup } from "react-bootstrap";

const StudentInformationItem = ({ label, value }) => (
  <ListGroup.Item>
    <div className="m-1">
      <div
        className="body-large-16-regular"
        style={{ color: "#666D80" }}
      >
        {label}
      </div>
      {!!value ? (
        <div
          className="body-large-16-medium"
          style={{ color: "#37394A" }}
        >
          {value}
        </div>
      ) : (
        <div className="body-large-16-medium text-danger">
          Missing information
        </div>
      )}
    </div>
  </ListGroup.Item>
);

const StudentInformationSection = ({
  containerClassName = "my-3",
  testGroupUser,
}) => {
  const { user, student_profile } = testGroupUser;
  return (
    <div className={containerClassName}>
      <h5 className="body-large-18-semibold mb-3 mt-5">
        Student information
      </h5>
      <Card>
        <ListGroup variant="flush">
          <StudentInformationItem
            label="Name"
            value={user.full_name}
          />
          <StudentInformationItem
            label="Grade"
            value={student_profile.grade}
          />
          <StudentInformationItem
            label="Email address"
            value={student_profile.parent_email_address}
          />
          <StudentInformationItem
            label="Phone number"
            value={student_profile.parent_phone_number}
          />
        </ListGroup>
      </Card>
    </div>
  );
};

export default StudentInformationSection;